import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, shareReplay, switchMap, tap } from 'rxjs/operators';
import { DecryptConfigService } from './decrypt-config.service';

export interface IApis {
  urlApi: string;
  urlApiAnalytics: string;
  production: string;
  version: string;
  deployment_date: string;
}

export interface Configuration {
  apis: IApis;
  assets: string[];
}

@Injectable({
  providedIn: 'root'
})
export class CiCdConfigService {

  private readonly CONFIG_URL = 'assets/ci-cd-config/configuration.json';
  private configuration$!: Observable<Configuration>;

  constructor(private http: HttpClient,
    private decryptService: DecryptConfigService
  ) {
  }

  // Actual cinfiiuración debe ser reemplazada por el metodo xloadConfigurations
  public xloadConfigurations(): Observable<Configuration> {
    if (!this.configuration$) {
      this.configuration$ = this.http.get<Configuration>(`${this.CONFIG_URL}`).pipe(
        // tap((configuration: Configuration) => { console.log('configuration', configuration); }),
        shareReplay(1)
      );
    }
    return this.configuration$;
  }

  public loadConfigurations(): Observable<Configuration> {
    if (!this.configuration$) {
      this.configuration$ = this.http.get<Configuration>(`${this.CONFIG_URL}`).pipe(
        tap((configuration: Configuration) => {
          console.error('configuration ==> ', configuration);
        }),
        switchMap((configuration: Configuration) => {
          const dataDecrypt$ = this.handleDecryptConfig(configuration);
          dataDecrypt$.subscribe((dataDecryptJson) => this.consoleLog('<--------------- APIS TESTER DECRYPT --------------->  ', dataDecryptJson)) // ELIMINAR EN PRODUCCION
          return dataDecrypt$;
        }
        ),
        shareReplay(1)
      );
    }

    console.log('Loading configurations from:', this.CONFIG_URL);
    return this.configuration$;
  }

  handleDecryptConfig(configuration: Configuration | any): Observable<Configuration> {
    const password: string = 'c0v2qa35bv1FUM+uZ5A3uNRdKCYhxhf7MG+UgTU5x9hIgQ=C';
    this.consoleLog('<--------------- PASSWORD - 15/JUL/2025 --------------->  ', password); // ELIMINAR EN PRODUCCION
    return from(this.decryptService.decryptConfig(configuration, password)).pipe(
      tap((config: any) => console.log('Decrypted Config:', config)),
      catchError((error: any) => {
        console.error('Error decrypting config:', error);
        return of({} as any);
      })
    );
  }

  consoleLog(featureMessage: string, object: any): void {
    const clgStyle: string = `color: #1cb0d3; background-color: #ffffff; font-size: .8rem; border-radius: .5rem; padding: .3rem .5rem;`;
    console.info(`%c${featureMessage}`, clgStyle);
    console.log(object);
  }

}

